module.exports = __webpack_public_path__ + "img/20190904163911152.6b0fc43b.jpg";